// extracted by mini-css-extract-plugin
export var button = "roundedButton-module--button--Tv6FR";
export var blue = "roundedButton-module--blue--mzKcW";
export var white = "roundedButton-module--white--JjNWF";